import type {
  AuthenticateOrganizationInfo,
  UserInfo as OrganizationApiUserInfo,
} from "../api/openapi/organization/types.gen";
import { Role } from "./roles";

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
}

export type OrganizationInfo = AuthenticateOrganizationInfo;

export const ApiRole = {
  none: Role.NONE,
  viewer: Role.ORG_VIEWER,
  standard: Role.ORG_EDITOR,
  admin: Role.ORG_ADMIN,
} as const;
export type ApiRole = (typeof ApiRole)[keyof typeof ApiRole];

export type AuthenticatePermissions = Pick<OrganizationApiUserInfo, "id"> & {
  name: string;
  status: UserStatus;
  organizations: OrganizationInfo[];
  email_verified?: boolean;
  superadmin: boolean;
  superadmin_mfa_required?: boolean;
  most_recently_used_organization_id?: number;
};

export interface AuthResult {
  permissions: AuthenticatePermissions;
}

export interface AuthenticateResponse {
  permissions: AuthenticatePermissions;
  token: string;
}

export enum ApiLoadingState {
  notLoading,
  loading,
  error,
}

export class ApiError extends Error {
  protected _statusCode: number | undefined = undefined;
  protected _details: Record<string, any> | undefined = undefined;

  constructor(statusCode?: number, details?: Record<string, any>) {
    super();
    this._statusCode = statusCode;
    this._details = details;
  }

  public get statusCode(): number | undefined {
    return this._statusCode;
  }

  public get details(): Record<string, any> | undefined {
    return this._details;
  }
}

export class ApiNotFoundError extends ApiError {}
